import { EventConfigData } from 'src/app/@data-services/event-config/event-config.data-model';

const EVENT_HUB_NAME_MAP: Record<string, string> = {
  DTECH2026: 'Content Library',
};

// Matches the reference app's LIBRARIES label convention (e.g. "DTECH
// library") — every library's masthead ends in "library" unless the
// organizer configures a different name via Information.Texts.ContentHubName.
const DEFAULT_HUB_NAME = 'library';

/**
 * Resolve the attendee-facing hub name:
 *  1. Read from config (Information.Texts.ContentHubName)
 *  2. Fall back to hardcoded per-event mapping
 *  3. Fall back to "library"
 */
export function resolveContentHubName(
  config: EventConfigData | null | undefined
): string {
  const configName = config?.Information?.Texts?.ContentHubName;
  if (configName) {
    return configName;
  }

  const eventId = config?.EventIdentifier;
  if (eventId && eventId in EVENT_HUB_NAME_MAP) {
    return EVENT_HUB_NAME_MAP[eventId];
  }

  return DEFAULT_HUB_NAME;
}

/**
 * The full masthead label (e.g. "Immersive Event Experiences library",
 * matching the reference app's `LibraryBrand.label`) — resolveContentHubName()
 * alone is a bare generic word ("library") once organizer-specific names
 * fall away, so anywhere it stands on its own (a heading, a browser tab
 * title) should use this instead of composing the two manually.
 */
export function resolveFullHubTitle(
  config: EventConfigData | null | undefined
): string {
  const hubName = resolveContentHubName(config);
  const eventName = config?.Information?.EventNameDisplay;
  return eventName ? `${eventName} ${hubName}` : `Rozie Synopsis - ${hubName}`;
}
